import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const SubscriptionButton = styled.button`
  padding-block: 8px;
  padding-inline: 12px;

  color: #001246;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
  white-space: nowrap;
  text-align: start;
  text-transform: uppercase;

  border-radius: 2px;

  background: #ffca05;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 6px;
    padding-inline: 10px;
  }
`;

export type SubscriptionButtonContainerProps = {
  $variant?: "dark" | "dark-blue" | "light-blue";
};

export const SubscriptionButtonContainer = styled.span<SubscriptionButtonContainerProps>`
  ${props => {
    switch (props.$variant) {
      case "dark":
        return css`
          ${SubscriptionButton} {
            color: #ffffff;

            background: #222222;
          }
        `;
      case "dark-blue":
        return css`
          ${SubscriptionButton} {
            color: #ffffff;
            font-weight: 700;

            background: #001246;
          }
        `;
      case "light-blue":
        return css`
          ${SubscriptionButton} {
            padding-block: 7px;
            padding-inline: 8px;

            color: #ffffff;

            background: #4585ff;
          }
        `;
      default:
        return null;
    }
  }}
`;
